import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import './styles.css';
import logo from './camino-log.svg';
import { createCaminoCollegeProfilePath } from '../../../utils/url';
import { wrapLink } from '../../../utils/index';

export default function CaminoPreviewPane({ editData }) {
  const hiid = get(editData, 'fullProfile.general.field_hiid', '');
  const name = get(editData, 'name', '');
  const state = get(editData, 'fullProfile.address.field_state_ref.field_state_short_name', '');
  const url = createCaminoCollegeProfilePath(hiid, name, state);
  const link = wrapLink('withcamino.com', url);
  return (
    <section styleName="camino-preview-pane" data-cy="camino-preview-pane">
      <img src={logo} alt="Camino logo" />
      <h1>Transfer Information</h1>
      <p>No Preview Available</p>
      <footer>After approval, all data entered here will be shown on your institution’s profile at {link}.</footer>
    </section>
  );
}
CaminoPreviewPane.propTypes = {
  editData: PropTypes.object,
};
